import React, { useState } from "react";
import "./Presence.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import camerron from "../../../icons/CameroonNew.png";
import congo from "../../../icons/CongoNew.png";
import Heading from "../../../utls/Heading";

const Presence = () => {
  const [activeRegion, setActiveRegion] = useState("UAE");
  const data = {
    UAE: (
      <div className="accordion accordion-flush" id="accordionFlushExample">
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingTone">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTone"
              aria-expanded="false"
              aria-controls="flush-collapseTone"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/UAE.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">UAE</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseTone"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingTone"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Dubai</h4>
                        <div className="phone-watts gap-1">
                          {/* <a href="tel:+971 4 770 7355">
                                                        <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' loading="lazy" />
                                                    </a> */}
                          {/* <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' loading="lazy"  /> */}
                        </div>
                      </div>
                      <div className="addres-text">
                        <p>
                          1210-11, The regal Tower, Business Bay, Dubai, UAE
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+971 4 770 7355">+971 4 770 7355</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
    Asia: (
      <div className="accordion accordion-flush" id="accordionFlushExample">
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingten">
            <button
              className="accordion-button collapsed "
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseten"
              aria-expanded="false"
              aria-controls="flush-collapseTen"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/India.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">India</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseten"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingten"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  {/* <!-- Card 1 --> */}
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Gurugram</h4>
                        <div className="phone-watts gap-1">
                          {/* <a href="tel:+91 977 330 3363">
                                                        <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' loading="lazy" />
                                                    </a> */}
                          {/* <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' loading="lazy" /> */}
                        </div>
                      </div>
                      <div className="addres-text">
                        <p>
                          503, DLF Galleria Tower, DLF Phase 4, Gurugram,
                          Haryana (122022)
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+91 977 330 3363">+91 977 330 3363</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Card 2 --> */}
                  <div className="col-md-4 mt-md-0 mt-2">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-4">Jaipur</h4>
                        {/* <div className="phone-watts gap-1">
                                                    <a href="+91 86900 01393">
                                                        <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' loading="lazy" />
                                                    </a>
                                                    <a href="+91 86900 01394">
                                                        <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' loading="lazy" />
                                                    </a>
                                                    <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' loading="lazy"  />
                                                </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          33/75, Varun Path, Mansarover, Jaipur, Rajasthan
                          (302020)
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+91 86900 01393">+91 86900 01393</a>
                          <a href="tel:+91 86900 01394">+91 86900 01394</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Card 3 --> */}
                  <div className="col-md-4 mt-md-0 mt-2">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-4 pe-md-2">Surat</h4>
                        {/* <div className="phone-watts gap-1">
                                                    <a href="tel:+91 261 403 3340">
                                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/phone-contact.png" alt="" className='phonee' loading="lazy" />
                                                    </a>
                                                    <a href="tel:+91 85117 83340">
                                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/phone-contact.png" alt="" className='phonee' loading="lazy" />
                                                    </a>
                                                    <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' loading="lazy" />
                                                </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          G32 & G32A International trade centre Majura gate Ring
                          road, Surat, Gujarat (39500)
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+91 261 403 3340">+91 261 403 3340</a>
                          <a href="tel:+91 85117 83340">+91 85117 83340</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
    Africa: (
      <div className="accordion accordion-flush" id="accordionFlushExample">
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingTten">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTten"
              aria-expanded="false"
              aria-controls="flush-collapseTten"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/Algeria.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Algeria</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseTten"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingTten"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Algiers</h4>
                        {/* <div className="phone-watts gap-1">
                                                    <a href="tel:+213 5 62 62 4030">
                                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/phone-contact.png" alt="" className='phonee' loading="lazy" />
                                                    </a>
                                                </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          15, Rue Hamdani Lahcen, 1er Etage, Sidi Yahia, Hydra,
                          Algiers, Algeria
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+213 5 62 62 4030">+213 5 62 62 4030</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingOne">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Angola.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Angola</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Luanda</h4>
                        {/* <div className="phone-watts gap-1">
                                                    <a href="tel:+244 225 030 030">
                                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/phone-contact.png" alt="" className='phonee' loading="lazy" />
                                                    </a>
                                                    <a href="tel:+244 938 718 050">
                                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/phone-contact.png" alt="" className='phonee' loading="lazy" />
                                                    </a>
                                                </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Rua Rei Katya vala,126-A, Indombota,Luanda, Angola
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+244 225 030 030">+244 225 030 030</a>
                          <a href="tel:+244 225 030 031">+244 225 030 031</a>
                          <a href="tel:+244 938 718 050">+244 938 718 050</a>
                          <a href="tel:+244 938 718 051">+244 938 718 051</a>
                          <a href="tel:+244225031031">+244225031031</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="accordion-item aItem india-bg">
                            <Heading level={2} className="accordion-header" id="flush-headingTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                    aria-controls="flush-collapseTwo">
                                    <div className="d-flex  mt-2">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/Boatswana.png" className="country-icon" alt="User Icon"  loading="lazy" />
                                        <p className="name fs4 mt-1">Botswana</p>
                                    </div>
                                </button>
                            </Heading>
                            <div id="flush-collapseTwo" className="accordion-collapse collapse"
                                aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body">
                                    <div className="card-containers ps-3 pe-3">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="india-box">
                                                    <div className="d-flex justify-content-between">
                                                        <h4 className='headings me-md-1'>Gaborone</h4>
                                                        
                                                    </div>
                                                    <div className="addres-text">
                                                        <p>Unit 13, Wing A Zambezi Tower, CBD, Gaborone, Botswana</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingThree">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseThree"
              aria-expanded="false"
              aria-controls="flush-collapseThree"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src={camerron}
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Cameroon</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseThree"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingThree"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Douala</h4>
                        {/* <div className="phone-watts gap-1">
                                                    <a href="tel:+237 233 432 022">
                                                        <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                    </a>
                                                    <a href="tel:+237 650 147 614">
                                                        <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                    </a>
                                                </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          22, Rue De L'hotel De ville, Acote Royal Air Maroc,
                          Bonanjo, Douala, Cameroon
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+237 233 432 022">+237 233 432 022</a>
                          <a href="tel:+237 650 147 614">+237 650 147 614</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Yaoundé</h4>
                      </div>
                      <div className="addres-text">
                        <p>
                          En Face Universite Panafricaine, acote Eneo Nglongkak,
                          Yaounde, Cameroon
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+ 237 222 207 115">+ 237 222 207 115</a>
                          <a href="tel:+237 671 617 778">+237 671 617 778</a>
                          <a href="tel:+237 692 000 117">+237 692 000 117</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingfour">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsefour"
              aria-expanded="false"
              aria-controls="flush-collapsefour"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/CAR.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">C.A.R</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsefour"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingfour"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Bangui</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Avenue B.Bognada En face Pharmacy Palome, à côté du
                          Grand Café RCA Bangui, CAR
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+236 751 06 199">+236 751 06 199</a>
                          <a href="tel:+236 72 08 35 94">+236 72 08 35 94</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingfive">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsefive"
              aria-expanded="false"
              aria-controls="flush-collapsefive"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src={congo}
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Congo</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsefive"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingfive"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Brazzavill</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Magasin M6 immeuble city center , Brazzaville
                          République du Congo
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+242 065 21 29 33">+242 065 21 29 33</a>
                          <a href="tel: +242 06 664 69 86">+242 06 664 69 86</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Pointe-Noire</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          146, Avenue Charles de Gaulle, Pointe-Noire (Republic
                          Of Congo)
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+242 06 809 57 18">+242 06 809 57 18</a>
                          <a href="tel: +242 06 664 69 86">+242 06 664 69 86</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingsix">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsesix"
              aria-expanded="false"
              aria-controls="flush-collapsesix"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Co.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Cô te d'Ivoire</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsesix"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingsix"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Abidjan</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Sarl au capital de 70 000 000 FCFA – Siège Social :
                          Abidjan, Plateau rue du commerce Imm. Nabil ,10 BP 496
                          Abidjan 10
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+225 07 87 07 75 11">
                            +225 07 87 07 75 11
                          </a>
                          <a href="tel: +225 27 21 59 35 16">
                            +225 27 21 59 35 16
                          </a>
                          <a href="tel:+225 07 97 1271 17">
                            +225 07 97 1271 17
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-4">
                                                <div className="india-box">
                                                    <div className="d-flex justify-content-between">
                                                        <h4 className='headings me-md-1'>Abidjan (AGENCE ZONE 4)</h4>

                                                    </div>
                                                    <div className="addres-text">
                                                        <p>SCI MALL ZONE 4,7em ÉTAGE MARCORY ZONE 4 C,11 BP 2498, ABIDJAN, Côte d’Ivoire</p>
                                                    </div>
                                                </div>
                                            </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="accordion-item aItem india-bg">
                            <Heading level={2} className="accordion-header" id="flush-headingseven">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseseven" aria-expanded="false"
                                    aria-controls="flush-collapseseven">
                                    <div className="d-flex  mt-2">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/Djibouti.png" className="country-icon" alt="User Icon" loading="lazy"  />
                                        <p className="name fs4 mt-1">Djibouti</p>
                                    </div>
                                </button>
                            </Heading>
                            <div id="flush-collapseseven" className="accordion-collapse collapse"
                                aria-labelledby="flush-headingseven" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body">
                                    <div className="card-containers ps-3 pe-3">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="india-box">
                                                    <div className="d-flex justify-content-between">
                                                        <h4 className='headings me-md-1'>Djibouti</h4>
                                                       
                                                    </div>
                                                    <div className="addres-text">
                                                        <p>Administrator Benard Djibouti</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingeight">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseeight"
              aria-expanded="false"
              aria-controls="flush-collapseeight"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Gabon.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Gabon</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseeight"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingeight"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Libreville</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          En Face Du Pmug, BP:7557,Centreville,A Cote Paul cafe,
                          Libreville, Gabon
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+241 74 83 73 73">+241 74 83 73 73</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingnine">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsenine"
              aria-expanded="false"
              aria-controls="flush-collapsenine"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Ghana.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Ghana</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsenine"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingnine"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Accara</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Behind No 1 Hotel, Nii Saban Atsen Street, Oxford St,
                          Accra, Ghana
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+233 260 333 444">+233 260 333 444</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingeleven">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseeleven"
              aria-expanded="false"
              aria-controls="flush-collapseeleven"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Kenya.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Kenya</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseeleven"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingeleven"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Mombasa</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Harbour House, Ground Floor Shop No. 1 Moi Ave,
                          Mombasa, Kenya
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+254 752 999 979">+254 752 999 979</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Nairobi</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Showroom no.3, ground floor, Western Heights, Karuna
                          Road, Westlands, Nairobi, Kenya
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel: +254 756 384 754">+254 756 384 754</a>
                          <a href="tel:+254 756 469 997">+254 756 469 997</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingtwelve">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsetwelve"
              aria-expanded="false"
              aria-controls="flush-collapsetwelve"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Madagascar.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Madagascar</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsetwelve"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingtwelve"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Antananarivo</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Immeuble Ex-Sicam, Analakely, Antananarivo, Madagascar
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel: +261 20 22 307 32">+261 20 22 307 32</a>
                          <a href="tel:+261 32 46 764 35">+261 32 46 764 35</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Antananarivo</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Immeuble ATRIUM -BP 4216 ANKORONDRANO
                          ,Antananarivo 101 Madagascar
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:  +261 20 22 307 36">
                            +261 20 22 307 36
                          </a>
                          <a href="tel:+261 34 91 897 51">+261 34 91 897 51</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Antananarivo</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Ivato international airport, Arrival zone,
                          Antananarivo, Madagascar
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+26133 70 602 06">+26133 70 602 06</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mt-2">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Toamasina</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          03 rue Marechal de Lattre de Tassigny, Opp BNI Bank,
                          Bazar Be, Toamasina, Madagascar
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel: +261 38 29 364 36">+261 38 29 364 36</a>
                          <a href="tel: +261 38 29 364 37">+261 38 29 364 37</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingthirteen">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsethirteen"
              aria-expanded="false"
              aria-controls="flush-collapsethirteen"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Malawi.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Malawi</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsethirteen"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingthirteen"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Blantyre</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Shop number 10 The Ginery Mall, Ginery Corner,
                          Blantyre, Malawi
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+265 997 69 17 76">+265 997 69 17 76</a>
                          <a href="tel:+265 994 66 03 91">+265 994 66 03 91</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Lilongwe</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>31, Crossroads Mall, Lilongwe, Malawi</p>
                        <div className="phoneTextContainer">
                          <a href="tel:+265 994 66 03 91">+265 994 66 03 91</a>
                          <a href="tel:+265 885 09 84 21">+265 885 09 84 21</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingfourteen">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsefourteen"
              aria-expanded="false"
              aria-controls="flush-collapsefourteen"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Mazambique.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Mozambique</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsefourteen"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingfourteen"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Maputo</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          No. 109, Rua Dar Es Salaam, Bairro da Sommerschield,
                          Cidade de Maputo, Mozambique
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+258 21 499 821">+258 21 499 821</a>
                          <a href="tel: +258 820 04 10 00">+258 820 04 10 00</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingfiveteen">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsefiveteen"
              aria-expanded="false"
              aria-controls="flush-collapsefiveteen"
            >
              <div className="d-flex  mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Namibia.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Namibia</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsefiveteen"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingfiveteen"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Windhoek</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Shop No.2, Garten Strasse Commercial, Building
                          Windhoek, Namibia
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+264 61 307 108">+264 61 307 108</a>
                          <a href="tel:+264 81 574 84 84">+264 81 574 84 84</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingsixteen">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsesixteen"
              aria-expanded="false"
              aria-controls="flush-collapsesixteen"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Nigeria.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Nigeria</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsesixteen"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingsixteen"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Abuja</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          3rd floor, Sinoki House, plot 770, beside ministery of
                          transport, abuja, FCT, 900211
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Kano</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>G8, Near Shoprite, Ado Bayero Mall, Kano</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Lagos</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Churchgate Tower - 1, 2nd Floor, Victoria Island,
                          Lagos, Nigeria
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+234 809 84 60 666">
                            +234 809 84 60 666
                          </a>
                          <a href="tel: +234 81 60 66 06 50">
                            +234 81 60 66 06 50
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingseventeen">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseseventeen"
              aria-expanded="false"
              aria-controls="flush-collapseseventeen"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/RDC.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">RDC</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseseventeen"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingseventeen"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Kinshasa</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Av. Boulevard du 30 juin n°835, Batiment Complexe
                          NZIGI EX Mwana NTEBA, Commune de la Gombe, Kinshasa
                          (RDC)
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+243 979 419 505">+243 979 419 505</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Lubumbashi</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          No. 010 Square George Arthur Forest, Quartier Kiwele,
                          Commune et Ville de Lubumbashi, RDC
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+243 999 153 604">+243 999 153 604</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingTfive">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTfive"
              aria-expanded="false"
              aria-controls="flush-collapseTfive"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/senegal.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Senegal</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseTfive"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingTfive"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Dakar</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Immeuble Tamaris, 11 Rue St Michel Dakar - Senegal
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+221 338408181">+221 338408181</a>
                          <a href="tel:+221 789923712">+221 789923712</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingeightteen">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseeightteen"
              aria-expanded="false"
              aria-controls="flush-collapseeightteen"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/South%20Africa.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">South Africa</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseeightteen"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingeightteen"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Johannesburg</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Block 3, Commerce Square, B300003, 39 Rivonia Rd,
                          Sandhurst, Johannesburg, 2196, South Africa
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+221 338408181">+221 338408181</a>
                          <a href="tel:+221 789923712">+221 789923712</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingnineteen">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsenineteen"
              aria-expanded="false"
              aria-controls="flush-collapsenineteen"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Tanzania.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Tanzania</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsenineteen"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingnineteen"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Dar Es Salaam</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          S-24, Ground Floor, Haidery Plaza, Kisutu,
                          Dar-Es-Salaam, Tanzania
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel: +255678227026">+255678227026</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Dar Es Salaam</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Terminal - 3, Julius K. Nyerere Airport, Dar es
                          Salaam, Tanzania
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+255 685 691067">+255 685 691067</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Dodoma</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Dodoma, Tanzania:- Plot no-6, Sido Street,
                          DODOMA-TANZANIA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingtwenty">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapsetwenty"
              aria-expanded="false"
              aria-controls="flush-collapsetwenty"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Togo.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Togo</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapsetwenty"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingtwenty"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Lome</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Avenue Augustino De Souza (Immeuble De la Paix) Sis Au
                          Quartier pa de Souza, Lome, Togo
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+22893340690">+22893340690</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="accordion-item aItem india-bg">
                            <Heading level={2} className="accordion-header" id="flush-headingTone">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTone" aria-expanded="false"
                                    aria-controls="flush-collapseTone">
                                    <div className="d-flex mt-2">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/UAE.png" className="country-icon" alt="User Icon" />
                                        <p className="name fs4 mt-1">UAE</p>
                                    </div>
                                </button>
                            </Heading>
                            <div id="flush-collapseTone" className="accordion-collapse collapse"
                                aria-labelledby="flush-headingTone" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body">
                                    <div className="card-containers ps-3 pe-3">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="india-box">
                                                    <div className="d-flex justify-content-between">
                                                        <h4 className='headings me-md-1'>Dubai</h4>
                                                        
                                                    </div>
                                                    <div className="addres-text">
                                                        <p>1210-11, The regal Tower, Business Bay, Dubai, UAE</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingTtwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTtwo"
              aria-expanded="false"
              aria-controls="flush-collapseTtwo"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Uganda.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Uganda</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseTtwo"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingTtwo"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Kampala</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Plot 08, Nita Building, Colville Street, Kampala
                          Uganda
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+256777629305">+256777629305</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingTthree">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTthree"
              aria-expanded="false"
              aria-controls="flush-collapseTthree"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Zambia.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Zambia</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseTthree"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingTthree"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box mb-2 mb-md-0">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Kitwe</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Office No 5 Soho Park Kanyanta Ave Opposite, Shebourne
                          near the after 10 round about. Parklands, Kitwe Zambia
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+260 212 23 65 68">+260 212 23 65 68</a>
                          <a href="tel: +260 974 33 33 99">+260 974 33 33 99</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Lusaka</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          13 D&D Centre, Makishi rd x Great East rd, Lusaka,
                          Zambia
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+260 211 23 32 23">+260 211 23 32 23</a>
                          <a href="tel: +260 971 33 34 44">+260 971 33 34 44</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item aItem india-bg">
          <Heading level={2} className="accordion-header" id="flush-headingTfour">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTfour"
              aria-expanded="false"
              aria-controls="flush-collapseTfour"
            >
              <div className="d-flex mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Zimbabwe.png"
                  className="country-icon"
                  alt="User Icon"
                  loading="lazy"
                />
                <p className="name fs4 mt-1">Zimbabwe</p>
              </div>
            </button>
          </Heading>
          <div
            id="flush-collapseTfour"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingTfour"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card-containers ps-3 pe-3">
                <div className="row">
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Harare</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>179, King George Road Avondale, Harare, Zimbabwe</p>
                        <div className="phoneTextContainer">
                          <a href="tel:+263 433 5 304">+263 433 5 304</a>
                          <a href="tel:+263 433 5 305">+263 433 5 305</a>
                          <a href="tel:+263 785 00 48 84">+263 785 00 48 84</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="india-box">
                      <div className="d-flex justify-content-between">
                        <h4 className="headings me-md-1">Harare</h4>
                        {/* <div className="phone-watts gap-1">
                                                            <LazyLoadImage
            effect="blur"
 src={phonecontact} alt="" className='phonee' />
                                                            <LazyLoadImage
            effect="blur"
 src={wattscontact} alt="" className='wattss' />
                                                        </div> */}
                      </div>
                      <div className="addres-text">
                        <p>
                          Blueberry Premium Lounge, No. 10, At New Terminal,
                          Robert Gabriel Mugabe International Airport, Departure
                          Gate, Harare, Zimbabwe
                        </p>
                        <div className="phoneTextContainer">
                          <a href="tel:+263 78 708 7341">+263 78 708 7341</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="accordion-item aItem india-bg">
                            <Heading level={2} className="accordion-header" id="flush-headingTsix">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTsix" aria-expanded="false"
                                    aria-controls="flush-collapseTsix">
                                    <div className="d-flex mt-2">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/Burkina.png" className="country-icon" alt="User Icon"  loading="lazy" />
                                        <p className="name fs4 mt-1">Burkina</p>
                                    </div>
                                </button>
                            </Heading>
                            <div id="flush-collapseTsix" className="accordion-collapse collapse"
                                aria-labelledby="flush-headingTsix" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body">
                                    <div className="card-containers ps-3 pe-3">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="india-box mb-2 mb-md-0">
                                                    <div className="d-flex justify-content-between">
                                                        <h4 className='headings me-md-1'>Ouagadougou</h4>
                                                       
                                                    </div>
                                                    <div className="addres-text">
                                                        <p>Angle Avenue Bouda Koulouba 11 BP 1202 CMS, Ouagadougou 11, Burkina Faso</p>
                                                    </div>
                                                </div>
                                            </div>
                                           

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
        {/* <div className="accordion-item aItem india-bg">
                            <Heading level={2} className="accordion-header" id="flush-headingTseven">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTseven" aria-expanded="false"
                                    aria-controls="flush-collapseTseven">
                                    <div className="d-flex mt-2">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/Rwanda.png" className="country-icon" alt="User Icon"  loading="lazy" />
                                        <p className="name fs4 mt-1">Rwanda</p>
                                    </div>
                                </button>
                            </Heading>
                            <div id="flush-collapseTseven" className="accordion-collapse collapse"
                                aria-labelledby="flush-headingTseven" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body">
                                    <div className="card-containers ps-3 pe-3">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="india-box mb-2 mb-md-0">
                                                    <div className="d-flex justify-content-between">
                                                        <h4 className='headings me-md-1'>Kigali</h4>
                                                        
                                                    </div>
                                                    <div className="addres-text">
                                                        <p>BPR Headquarters Building, Lower Ground, Junction of KN 67 & KN 30, Nyarugenge District, Kigali, Rwanda</p>
                                                    </div>
                                                </div>
                                            </div>
                                           

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
      </div>
    ),
  };
  return (
    <>
      <div className=" container presence-section px-lg-5 mb-5 mt-4 mt-md-0">
        <div className="row px-md-3 px-2">
          <div className="col-md-12 mt-4">
            <div className="row px-md-2">
              <div className="col-lg-7">
                <Heading className="headings presenceheading text-md-center text-lg-start">
                  Making a <span>Presence</span> in Every Part of The World!
                </Heading>
              </div>
              <div className="col-lg-5">
                <div className="button-group">
                  {["UAE", "Asia", "Africa"].map((region) => (
                    <button
                      key={region}
                      className={`region-button ${
                        activeRegion === region ? "active" : ""
                      }`}
                      onClick={() => setActiveRegion(region)}
                    >
                      {region}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="region-data  mb-md-4 mb-5">
            {data[activeRegion]}
          </div>
        </div>
      </div>
    </>
  );
};

export default Presence;
